<template>
  <div class="purchase_index">
    <div class="purchase_index_nav">
      <navbar
        title="提现管理"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        :titlecolor="'#fff'"
        @goback="goBack(false)"
      />
    </div>
    <van-row class="box">
      <van-col span="24" class="manage">
        <div class="info">
          <div class="desc">
            <p>可提现金额</p>
            <p class="num">{{ supplierInfo.with_drawable_cash || "0.00" }}</p>
            <p
              class="frozen"
              v-if="
                supplierInfo.freeze_balance && supplierInfo.freeze_balance != 0
              "
            >
              冻结：¥{{ supplierInfo.freeze_balance
              }}<van-icon name="question-o" @click="frozenTip" />
            </p>
          </div>
          <div class="desc desc_other" @click="settled">
            <img
              src="../../../assets/purchaseSupplier/withdraw/withdraw_banlance.png"
              alt=""
            />
            <p>收支明细</p>
            <!-- <p class="num">{{ supplierInfo.supplier_settled || "0.00" }}</p> -->
          </div>
          <div class="desc desc_other" @click="withdraw">
            <img
              src="../../../assets/purchaseSupplier/withdraw/withdraw_detail.png"
              alt=""
            />
            <p>提现记录</p>
            <!-- <p class="num">{{ supplierInfo.supplier_withdrawn || "0.00" }}</p> -->
          </div>
          <btn
            :btntext="'提现'"
            :btnwidth="'30.3rem'"
            :height="'4.8rem'"
            :bgcolor="'linear-gradient(to right, #FFB12F, #FF5E2F)'"
            :borderradius="'0.4rem'"
            :btncolor="'#fff'"
            :fontsize="'1.6rem'"
            :fontweight="700"
            :btnmargin="'0 0 0 2rem'"
            @btnClick="toWithdraw"
          />
        </div>
        <div class="operationItem" @click="accountManage">
          <img
            src="../../../assets/purchaseSupplier/withdraw/account.png"
            alt=""
          />
          对公账户
          <van-icon name="arrow" />
        </div>
        <div class="operationItem" @click="alipayAccountManage">
          <img
            src="../../../assets/purchaseSupplier/withdraw/alipay.png"
            alt=""
          />
          企业支付宝
          <van-icon name="arrow" />
        </div>
        <div class="operationItem" @click="invoiceManage">
          <img
            src="../../../assets/purchaseSupplier/withdraw/invoice.png"
            alt=""
          />
          发票管理
          <van-icon name="arrow" />
        </div>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/my/reback.png"),
      supplierInfo: {},
    };
  },
  created() {
    this.getInfo();
  },
  mounted() {
    document
      .querySelector(".box")
      .addEventListener("scroll", this.handleScroll);
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getInfo() {
      this.$api
        .post("member-relation/member/three/year/supplier/detail", {
          id: this.$route.query.id,
        })
        .then((res) => {
          this.supplierInfo = res;
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    frozenTip() {
      this.$dialog
        .confirm({
          message:
            "因系统更新，您的冻结货款暂时无法提现，请联系销巴集采部处理，敬请谅解，谢谢！",
          confirmButtonText: "我知道了",
          confirmButtonColor: "#F9591B",
          showCancelButton: false,
        })
        .then(() => {
          // on confirm
        });
    },
    settled() {
      this.$router.push({
        path: "/purchaseSupplier/settle",
        query: {
          id: this.$route.query.id,
        },
      });
    },
    withdraw() {
      localStorage.setItem("withdraw_info", JSON.stringify(this.supplierInfo));
      this.$router.push({
        path: "/purchaseSupplier/withdrawRecord",
        query: {
          id: this.$route.query.id,
        },
      });
    },
    toSign() {
      let parm = {
        url: this.supplierInfo.base_file_url,
        is_resign: 1,
      };
      this.params(JSON.stringify(parm), JSON.stringify(parm), "toSign");
    },
    contractStatus() {
      let parm = {
        resign_status: this.supplierInfo.resign_status,
        resign_remark: this.supplierInfo.resign_remark,
      };
      this.params(JSON.stringify(parm), JSON.stringify(parm), "contractStatus");
    },
    toWithdraw() {
      //补签中is_resign == 1 存在以下4种状态  补签完成不需要弹框（此时直接跳到对应页面即可，需要处理跳转事件）
      //!resign_status未提交信息//resign_status=2补签完成//resign_status=3补签合同待签署//resign_status=0合同待审核，1平台待审核，-1合同已驳回补签合同审核状态
      if (Number(this.supplierInfo.with_drawable_cash) < 1) {
        this.$toast("可提现金额小于1元不可提现");
        return;
      } else if (this.supplierInfo.is_resign == 1) {
        if (
          (!this.supplierInfo.resign_status ||
            this.supplierInfo.resign_status == 2) &&
          this.supplierInfo.resign_status != 0
        ) {
          //未提交信息
          this.$dialog
            .confirm({
              message: this.supplierInfo.pop_content,
              confirmButtonText: "去签署",
              confirmButtonColor: "#FC740C",
              cancelButtonText: "放弃",
              cancelButtonColor: "#999",
            })
            .then(() => {
              // on confirm
              this.$router.push({
                path: "/purchaseSupplier/selectIndentity",
                query: {
                  supplier_id: this.$route.query.id,
                  from: "index",
                  resign: 1,
                },
              });
            })
            .catch(() => {
              // on cancel
            });
        } else if (this.supplierInfo.resign_status == 2) {
          localStorage.setItem(
            "withdraw_info",
            JSON.stringify(this.supplierInfo)
          );
          localStorage.removeItem("selectedOrderInfo");
          this.$router.push({
            path: "/purchaseSupplier/toWithdraw",
            query: {
              id: this.$route.query.id,
              supplier_number: this.$route.query.supplier_number,
            },
          });
        } else if (this.supplierInfo.resign_status == 3) {
          //补签合同待签署
          this.$dialog
            .confirm({
              message: this.supplierInfo.pop_content,
              confirmButtonText: "去签署",
              confirmButtonColor: "#FC740C",
              cancelButtonText: "放弃",
              cancelButtonColor: "#999",
            })
            .then(() => {
              // on confirm
              this.toSign();
            });
          // .catch(() => {
          //   // on cancel
          // });
        } else {
          //补签合同审核状态
          this.$dialog
            .confirm({
              message: this.supplierInfo.pop_content,
              confirmButtonText: "去签署",
              confirmButtonColor: "#FC740C",
              cancelButtonText: "放弃",
              cancelButtonColor: "#999",
            })
            .then(() => {
              // on confirm
              this.contractStatus();
            });
          // .catch(() => {
          //   // on cancel
          // });
        }
      } else if (
        this.supplierInfo.is_resign != 1 &&
        this.supplierInfo.balance_status == 1
      ) {
        this.$dialog
          .confirm({
            title: "禁止提现",
            message: this.supplierInfo.balance_content,
            confirmButtonText: "去上传",
            confirmButtonColor: "#FC740C",
            cancelButtonText: "放弃",
            cancelButtonColor: "#999",
          })
          .then(() => {
            // on confirm
            this.$router.push({
              path: "/purchaseSupplier/invoice",
              query: {
                contract_type: this.supplierInfo.contract_type,
                tax_type: this.supplierInfo.tax_type,
              },
            });
          })
          .catch(() => {
            // on cancel
          });
      } else {
        localStorage.setItem(
          "withdraw_info",
          JSON.stringify(this.supplierInfo)
        );
        this.$router.push({
          path: "/purchaseSupplier/toWithdraw",
          query: {
            id: this.$route.query.id,
            supplier_number: this.$route.query.supplier_number,
          },
        });
      }
    },
    invoiceManage() {
      this.$router.push({
        path: "/purchaseSupplier/invoice",
        query: {
          contract_type: this.supplierInfo.contract_type,
          tax_type: this.supplierInfo.tax_type,
        },
      });
    },
    accountManage() {
      localStorage.setItem("withdraw_info", JSON.stringify(this.supplierInfo));
      this.$router.push("/purchaseSupplier/account");
    },
    alipayAccountManage() {
      localStorage.setItem("withdraw_info", JSON.stringify(this.supplierInfo));
      if (this.supplierInfo.list == 1) {
        this.$router.push("/purchaseSupplier/alipay");
      } else {
        this.$router.push("/purchaseSupplier/bind");
      }
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.purchase_index {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .purchase_index_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    z-index: 3;
  }

  .box {
    box-sizing: border-box;
    height: 100%;
    padding-top: 10.4rem;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    background: url(../../../assets/purchaseSupplier/withdraw/bg.png) no-repeat
      center top;
    background-size: 100% 24rem;

    .manage {
      padding: 0 1.6rem;
      height: calc(100% - 11.7rem);
      box-sizing: border-box;
      position: relative;

      .info {
        width: 100%;
        height: 31.9rem;
        background: #fff;
        margin-bottom: 1.2rem;
        border-radius: 0.8rem;
        padding: 4.8rem 0 2rem;
        box-sizing: border-box;

        .desc {
          text-align: center;
          position: relative;

          p {
            color: #999;
            font-size: 1.4rem;
            height: 2rem;
            line-height: 2rem;

            .van-icon {
              width: 1.6rem;
              height: 1.6rem;
              vertical-align: middle;
            }
          }

          .num {
            color: #333;
            font-size: 4.8rem;
            font-weight: 700;
            height: 5.6rem;
            line-height: 5.6rem;
            margin-top: 0.8rem;
          }

          .frozen {
            font-size: 1.2rem;
            height: 1.7rem;
            line-height: 1.7rem;
            position: absolute;
            bottom: -2.1rem;
            left: 0;
            width: 100%;
          }
        }

        .desc_other {
          width: 50%;
          float: left;
          margin: 3.3rem 0 3.2rem;

          img {
            width: 2.1rem;
            margin-bottom: 0.4rem;
          }

          .num {
            font-size: 2rem;
            height: 2.4rem;
            line-height: 2.4rem;
            margin-top: 1rem;
          }
        }
      }

      .goods {
        width: 16.5rem;
        background: #fff;
        height: 14.9rem;
        border-radius: 0.8rem;
        float: left;
        margin-top: -16.1rem;
        padding: 2.3rem 2rem 2rem 2.1rem;
        box-sizing: border-box;

        .number {
          color: #333;
          font-size: 2.4rem;
          line-height: 2.8rem;
          font-weight: 700;
          margin-bottom: 0.8rem;
        }

        .type {
          color: #666;
          font-size: 1.4rem;
          line-height: 2rem;
          margin-bottom: 2.2rem;
        }

        img {
          width: 2.9rem;
          float: right;
        }
      }

      .receive {
        float: right;
      }

      .operationItem {
        height: 7.8rem;
        line-height: 7.8rem;
        border-radius: 0.8rem;
        background: #fff;
        margin-bottom: 1.2rem;
        padding: 0 2.8rem;
        box-sizing: border-box;
        color: #333;
        font-size: 1.6rem;
        font-weight: 700;

        img {
          float: left;
          width: 2.2rem;
          margin: 2.8rem 2rem 0 0;
        }

        .van-icon {
          float: right;
          width: 1.6rem;
          font-weight: 400;
          color: #999;
          margin-top: 3.1rem;
        }
      }
    }
  }
}
.van-dialog {
  border-radius: 0.3rem !important;

  .van-dialog__confirm,
  .van-dialog__cancel {
    height: 5.2rem;
    font-size: 1.6rem;
  }

  .van-dialog__content--isolated {
    min-height: 6.2rem;

    .van-dialog__message {
      padding: 2.1rem 1rem;
      color: #666;
      font-weight: 700;
      font-size: 1.6rem;
    }
  }
}
</style>
